import { render, staticRenderFns } from "./bottomRightBtm.vue?vue&type=template&id=67b5ca8b&scoped=true&"
import script from "./bottomRightBtm.vue?vue&type=script&lang=js&"
export * from "./bottomRightBtm.vue?vue&type=script&lang=js&"
import style0 from "./bottomRightBtm.vue?vue&type=style&index=0&id=67b5ca8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5ca8b",
  null
  
)

export default component.exports